import React, {useContext, useState} from 'react'
import client from '../images/photo2.jpg'
import '../styles/modalbox.scss'
import {useTranslation} from "react-i18next";
import {
    addClientToBlackList, deleteClient,
    removeClientFromBlackList,
    showAlert,
    updateClient
} from "../redux/actions";
import {useDispatch} from "react-redux";
import {Carcontext} from "../context/carcontext";

const edit = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="edit" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M417.8 315.5l20-20c3.8-3.8 10.2-1.1 10.2 4.2V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h292.3c5.3 0 8 6.5 4.2 10.2l-20 20c-1.1 1.1-2.7 1.8-4.2 1.8H48c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V319.7c0-1.6.6-3.1 1.8-4.2zm145.9-191.2L251.2 436.8l-99.9 11.1c-13.4 1.5-24.7-9.8-23.2-23.2l11.1-99.9L451.7 12.3c16.4-16.4 43-16.4 59.4 0l52.6 52.6c16.4 16.4 16.4 43 0 59.4zm-93.6 48.4L403.4 106 169.8 339.5l-8.3 75.1 75.1-8.3 233.5-233.6zm71-85.2l-52.6-52.6c-3.8-3.8-10.2-4-14.1 0L426 83.3l66.7 66.7 48.4-48.4c3.9-3.8 3.9-10.2 0-14.1z"></path></svg>
const save = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="save" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM288 64v96H96V64h192zm128 368c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h16v104c0 13.255 10.745 24 24 24h208c13.255 0 24-10.745 24-24V64.491a15.888 15.888 0 0 1 7.432 4.195l83.882 83.882A15.895 15.895 0 0 1 416 163.882V432zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 144c-30.879 0-56-25.121-56-56s25.121-56 56-56 56 25.121 56 56-25.121 56-56 56z"></path></svg>
const block = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="ban" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zM103.265 408.735c-80.622-80.622-84.149-208.957-10.9-293.743l304.644 304.643c-84.804 73.264-213.138 69.706-293.744-10.9zm316.37-11.727L114.992 92.365c84.804-73.263 213.137-69.705 293.743 10.9 80.622 80.621 84.149 208.957 10.9 293.743z"></path></svg>
const cancel = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="align-slash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M536 304h-77.57l40.64 32H536a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8zm8-120a8 8 0 0 0-8-8H295.89l40.63 32H536a8 8 0 0 0 8-8zm-8-104a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8H133.34L174 80zM96 328a8 8 0 0 0 8 8h240l-40.64-32H104a8 8 0 0 0-8 8zm541 157.32L23 1.8A7.86 7.86 0 0 0 11.79 3l-10 12.5A7.92 7.92 0 0 0 3 26.71l614 483.52a7.91 7.91 0 0 0 11.18-1.23l10-12.5a7.83 7.83 0 0 0-1.18-11.18zM104 432a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h402.55l-40.64-32zm0-224h77.45l-40.64-32H104a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8z"></path></svg>
const unblock = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="unlock-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M336 256H96v-96c0-70.6 25.4-128 96-128s96 57.4 96 128v20c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-18.5C320 73.1 280.9.3 192.5 0 104-.3 64 71.6 64 160v96H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm16 208c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v160zm-160-32c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 8.8-7.2 16-16 16z"></path></svg>
const trash = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z"></path></svg>

const ClientModalBox = (prop) => {

    const {t} = useTranslation()
    const dispatch = useDispatch()
    const [edited, setEdited] = useState({})
    const [editable, setEditable] = useState(false)

    const { CloseModal } = useContext(Carcontext)

    const params = {
        "contentEditable": editable,
        "suppressContentEditableWarning": true
    }

    function handleUpdates(event) {
        setEdited({
            ...edited, [event.target.id]: event.target.innerText
        })
    }

    function allowEdit() {
        setEditable(prev => !prev)
    }

    function saveUpdates(e, id) {
        e.preventDefault()
        if (JSON.stringify(edited) === '{}') {
            dispatch(showAlert(`You did not change anything`, `warning`))
        } else {
            dispatch(updateClient(id, edited))
        }
        setEditable(false)
        CloseModal()
    }

    function addToABlackList(e, id) {
        e.preventDefault()
        const description = prompt(`Message for black list`)
        dispatch(addClientToBlackList(id, {"client_id": `${id}`, description}))
        CloseModal()
    }

    function unblockUser(e, id) {
        e.preventDefault()
        dispatch(removeClientFromBlackList(id))
        CloseModal()
    }

    function reset() {
        for (let member in edited) delete edited[member];
        setEditable(false)
        const img = document.querySelector('.client-imagebox')
        img.classList.remove('scaled')
    }

    function deleteUser(e, client) {
        e.preventDefault()
        const conf = window.confirm(`Do you wish to delete ${client.firstname} ${client.lastname} ?`)
        if (conf) {
            dispatch(deleteClient(client.client_id))
        }
        CloseModal()
    }

    function scaleImage(e) {
        e.stopPropagation()
        const img = document.querySelector('.client-imagebox')
        img.classList.toggle('scaled')
    }

    if (!prop.clients) {
        return (
            <div className="modal">

            </div>
        )
    }

    return (
        <div className="functional-layer" onMouseLeave={reset}>
            <div className={`client-modalbox ${prop.theme}`}>
                {
                    !!prop.clients.chat_id ? null :
                        <div className={`edit ${editable}`} onClick={allowEdit}>
                            {edit}
                        </div>
                }
                <div className="client-top">
                    <div className="client-left">
                        <div className="client-imagebox">
                            <img onClick={e => scaleImage(e)} className="client-image" src={
                                !!prop.clients.chat_id ?
                                    // if this modalbox for telegram client
                                    !!prop.clients.photo ? prop.clients.photo : client:
                                    // if this modalbox for ordinary client
                                    !!prop.clients.photo ? `https://rezilizer.ru/${prop.clients.photo}` : client
                            } alt="client: client" />
                        </div>
                        <div className="client-info">
                            <h2 className={`client-info-surname ${editable}`} id="lastname" onInput={handleUpdates} {...params}>{prop.clients.lastname}</h2>
                            <h2 className={`client-info-name ${editable}`} id="firstname" onInput={handleUpdates} {...params}>{prop.clients.firstname}</h2>
                            <h2 className={`client-info-second-name ${editable}`} id="second_name" onInput={handleUpdates} {...params}>{prop.clients.second_name}</h2>
                            <p className={`client-number ${editable}`} id="passport_series" onInput={handleUpdates} {...params}>{prop.clients.passport_series}</p>
                        </div>
                    </div>
                    <div className="client-right">
                        <div className="client-conditions">
                            <div className="client-isblock">
                                <div className={`client-block ${prop.clients.in_black_list}`}></div>
                                <span className="client-block-status">{t('blacList')}</span>
                            </div>
                            <div className="client-isactive">
                                <div className={`client-vacant ${prop.clients.status}`}></div>
                                <span className="client-vacant-status">{t(`${prop.clients.status}`)}</span>
                            </div>
                        </div>
                        <div className="client-rent-dates">
                            <div className="client-dates-item">
                                <h5 className="client-title dates-title">{t('dateofissue')}</h5>
                                <p className={`client-descr dates-descr ${editable}`} id="date_of_issue" onInput={handleUpdates} {...params}>
                                    {new Date(prop.clients.date_of_issue).toLocaleDateString()}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="client-content">
                    <div className="client-content-item">
                        <h4 className="client-title item-title">{t('dateofbirth')}</h4>
                        <p className={`client-descr item-descr ${editable}`} id="date_of_birth" onInput={handleUpdates} {...params}>
                            {new Date(prop.clients.date_of_birth).toLocaleDateString()}
                        </p>
                    </div>
                    <div className="client-content-item">
                        <h4 className="client-title item-title">{t('address')}</h4>
                        <p className={`client-descr item-descr ${editable}`} onInput={handleUpdates} {...params}>
                            {prop.clients.address}
                        </p>
                    </div>
                    <div className="client-content-item">
                        <h4 className="client-title item-title">{t('telephone')}</h4>
                        <p className={`client-descr item-descr ${editable}`} id="phone" onInput={handleUpdates} {...params}>
                            +998 {prop.clients.phone}
                        </p>
                    </div>
                </div>
                <div className="buttons">
                    {
                        editable ? <>
                            {
                                prop.clients.in_black_list ? <div className="rent-btn unblock" onClick={e => unblockUser(e, prop.clients.client_id)}><p>{t('unblock')}</p>{unblock}</div> :
                                    <div className="rent-btn blackList" onClick={e => addToABlackList(e, prop.clients.client_id)}><p>{t('block')}</p>{block}</div>
                            }
                            <div className="rent-btn cancel" onClick={CloseModal}><p>{t('cancel')}</p>{cancel}</div>
                            <div className="rent-btn save" onClick={e => saveUpdates(e, prop.clients.client_id)}><p>{t('save')}</p>{save}</div>
                            <div className="rent-btn delete" onClick={e => deleteUser(e, prop.clients)}><p>{t('delete')}</p>{trash}</div>
                        </> : null

                    }
                </div>
            </div>
        </div>
    )
}

export default  React.memo(ClientModalBox)
